import { render, staticRenderFns } from "./ModalTeamDetail.vue?vue&type=template&id=f05f0f28"
import script from "./ModalTeamDetail.vue?vue&type=script&lang=js"
export * from "./ModalTeamDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalTeamDetail.vue?vue&type=style&index=0&id=f05f0f28&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f05f0f28')) {
      api.createRecord('f05f0f28', component.options)
    } else {
      api.reload('f05f0f28', component.options)
    }
    module.hot.accept("./ModalTeamDetail.vue?vue&type=template&id=f05f0f28", function () {
      api.rerender('f05f0f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/team/components/ModalTeamDetail.vue"
export default component.exports